import { useQuery } from '@tanstack/react-query';
import { Activity, DollarSign, Eye, MousePointerClick, Sparkles, TrendingUp } from 'lucide-react';
import { boostApi } from '@/lib/api';
import { KpiCard } from '@/components/KpiCard';
import { PromotionTable } from '@/components/PromotionTable';

export function DashboardPage() {
  const overviewQ = useQuery({ queryKey: ['boost', 'overview'], queryFn: () => boostApi.overview() });
  const promotionsQ = useQuery({ queryKey: ['boost', 'by-promotion'], queryFn: () => boostApi.byPromotion() });

  const o = overviewQ.data;

  return (
    <div className="mx-auto max-w-6xl space-y-8">
      <div>
        <h1 className="text-3xl font-bold">Overview</h1>
        <p className="mt-1 text-text-secondary">
          Last 30 days · all your venues
        </p>
      </div>

      <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-6">
        <KpiCard
          label="Active boosts"
          value={o?.active_boosts ?? '—'}
          icon={<Sparkles size={16} />}
          tone="brand"
        />
        <KpiCard
          label="MTD spend"
          value={o ? `$${Number(o.month_to_date_spend_cad ?? 0).toFixed(0)}` : '—'}
          icon={<DollarSign size={16} />}
        />
        <KpiCard
          label="Impressions"
          value={o ? formatCompact(o.impressions_30d) : '—'}
          icon={<Eye size={16} />}
        />
        <KpiCard
          label="Clicks"
          value={o ? formatCompact(o.clicks_30d) : '—'}
          icon={<MousePointerClick size={16} />}
        />
        <KpiCard
          label="CTR"
          value={o ? `${(Number(o.ctr_30d ?? 0) * 100).toFixed(2)}%` : '—'}
          icon={<TrendingUp size={16} />}
        />
        <KpiCard
          label="Going clicks"
          value={o ? formatCompact(o.going_clicks_30d) : '—'}
          icon={<Activity size={16} />}
        />
      </div>

      <section className="card">
        <header className="mb-4 flex items-center justify-between">
          <h2 className="text-lg font-bold">Recent boosts</h2>
          <p className="text-sm text-text-muted">Last 50 entries</p>
        </header>
        <PromotionTable rows={promotionsQ.data ?? []} isLoading={promotionsQ.isLoading} />
      </section>
    </div>
  );
}

function formatCompact(n: number | string | null | undefined): string {
  // Postgres NUMERIC sütunları PHP json_encode aracılığıyla string olarak gelir.
  // Number() ile koru ki .toFixed / karşılaştırmalar NaN'a düşmesin.
  const v = Number(n ?? 0);
  if (!Number.isFinite(v)) return '—';
  if (v >= 1_000_000) return `${(v / 1_000_000).toFixed(1)}M`;
  if (v >= 1_000) return `${(v / 1_000).toFixed(1)}K`;
  return v.toString();
}
